import React, { useEffect, useState } from "react";
import * as image from "../../resources/images";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { PATHS } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { courseEnrollmentWithSession, getAllUsersDetail, getDimPlanCours, getSettingData, getUserProfile, logoutAction, selectedPlan, updateLearnerPlan } from "../../redux/actions/APIs";
import { billingPlan, defaultChild, getLoggedInUser } from "../../redux/actions";
import { AddChild } from "../base";
import AddLearner from "./AddLearner";
import SidebarNew from "../base/SidebarNew";
import { datesorting, getCalculatePlanDate, getCapitalized, getName, getProfileName, textTrim } from "../../utils/helper";
import UserPinPopUp from "./UserPinPopUp";
import { ShimmerSimpleGallery } from "react-shimmer-effects";
const UserProfile = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const {
		alluserdetails,
		isAuth,
		loggedInUser,
		defaultChildData,
		userProfileResponse,
		userPinRespnse,
		verifyPinResponse,
		mySelectType ,
		signupresponse,
		signinresponse,
		billingDetails,
		settingData,
		coursePlanResponse,
		courseEnrollResponse,
		response,
	} = useSelector((state) => state.collections);
	//	console.log("UserProfile : ", loggedInUser, defaultChildData);

	const [showChild, setShowChild] = useState(false);
	const [userData, setUserData] = useState();
	const [windowSize, setWindowSize] = useState(window.innerWidth);

	useEffect(() => {
		dispatch(getAllUsersDetail());
	}, []);

	 useEffect(()=>{
			if(signupresponse?.success && billingDetails){
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'SignUp',
					userEmail: billingDetails.email
				});
				window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({
							event: 'Subscription',
							userSubscription: billingDetails?.planData.name,
							username: billingDetails.email,
						});
				let data = {
								planData: billingDetails?.planData,
								stripeObj: billingDetails?.billingObj,
								userId: signupresponse?.records[0]?.childId,
								tnc: true,
								stripePromocode: billingDetails?.promocodeObj?.stripePromocode,
								promocode_id: billingDetails?.promocodeObj?.id,
								userPromocode: billingDetails?.userPromocode,
							};
				
							dispatch(selectedPlan(data));
				// console.log("mySelectedPlan @@ 11: ",signupresponse,billingDetails, window.dataLayer);
							dispatch(billingPlan());
			}
		},[signupresponse])


	useEffect(() => {
			if (signupresponse?.success && !signupresponse?.isTemp && alluserdetails?.records?.length > 0) {
				signupresponse.isTemp = true;
				if (signupresponse && signupresponse?.records[0]?.planId && signupresponse?.records[0]?.childId) {
					dispatch(getDimPlanCours(signupresponse?.records[0]?.childId, signupresponse?.records[0]?.planId));
				} else if (signupresponse && signupresponse?.records[0]?.courseId) {
					let childData = alluserdetails?.records[0]?.children[0];
					dispatch(getSettingData(childData?.id, childData?.level?.id));
				}
			}
		}, [alluserdetails])

		useEffect(() => {
			if (signinresponse?.success && !signinresponse?.isTemp && alluserdetails?.records?.length > 0) {
				signinresponse.isTemp = true;
				let childData = alluserdetails?.records[0]?.children[0];
				if (signinresponse && signinresponse?.planId && childData?.id) {
					dispatch(getDimPlanCours(childData?.id, signinresponse?.planId));
				} else if (signinresponse && signinresponse?.courseId) {
					dispatch(getSettingData(childData?.id, childData?.level?.id));
				}
			}
		}, [alluserdetails])
	
		useEffect(() => {
			if (settingData?.records?.length > 0 && (signupresponse?.records[0]?.courseId || signinresponse?.courseId)) {
				let userData = signupresponse?.records?.length > 0 ?  signupresponse?.records[0] : signinresponse;
				let weekArr = [];
				let todayDate = new Date();
				for (let i = 0; i < 2; i++) {
					let weekDay = new Date(todayDate).toLocaleString("en-us", { weekday: 'short' });
					weekArr?.push(weekDay);
					todayDate.setDate(todayDate.getDate() + 1);
				}
				let myCourseArr = settingData?.records?.find((item) => item?.id === userData?.courseId)
				handleCalculateStartDateEndDate(
					[myCourseArr],
					2,
					30,
					weekArr,
					userData?.childId
				);
				dispatch(getSettingData());
			}
		}, [settingData])
	
		useEffect(() => {
			if (coursePlanResponse?.records?.length > 0) {
				let weekArr = [];
				let todayDate = new Date();
				for (let i = 0; i < 2; i++) {
					let weekDay = new Date(todayDate).toLocaleString("en-us", { weekday: 'short' });
					weekArr?.push(weekDay);
					todayDate.setDate(todayDate.getDate() + 1);
				}
				handleCalculateStartDateEndDate(
					coursePlanResponse?.records,
					2,
					30,
					weekArr
				);
				dispatch(getDimPlanCours());
			}
		}, [coursePlanResponse]);
	
		const handleCalculateStartDateEndDate = (data, sitting, duration, weekArr, childId) => {
			let getPlanDateArr = getCalculatePlanDate(data, duration, sitting, "", weekArr)
			if (getPlanDateArr?.length > 0) {
				let signUpData = signupresponse?.records[0];
				let array = {
					name: signUpData?.planName ? signUpData?.planName : data[0]?.name,
					sittings: 2,
					duration: 30,
					planCount: 1,
					timeZone: signUpData?.timeZone,
					planType: signUpData?.planType,
					planId: childId ? "" : data[0]?.planId,
					daysOfWeek: weekArr,
					courses: getPlanDateArr
				};
				if (childId) {
					array.iscourseupdate = true;
					array.userId = signupresponse?.records[0]?.childId;
					dispatch(courseEnrollmentWithSession(childId, data[0]?.skillId, data[0]?.id, array));
				} else {
					dispatch(updateLearnerPlan(alluserdetails?.records[0]?.children[0]?.id, alluserdetails?.records[0]?.id, array))
				}
			}
		};

		useEffect(()=>{
			if(response?.success || courseEnrollResponse?.success){
				dispatch(getAllUsersDetail());
				dispatch(courseEnrollmentWithSession());
				dispatch(updateLearnerPlan())
			}
		},[response, courseEnrollResponse])

	

	useEffect(() => {
		if (alluserdetails && isAuth) {
			dispatch(getLoggedInUser(alluserdetails));
			dispatch(getUserProfile(alluserdetails?.records[0]?.id));
			if (alluserdetails?.records[0]?.children?.length > 0) {
				dispatch(defaultChild(alluserdetails?.records[0]?.children[0]));
			}
		}
	}, [alluserdetails]);

	const handleParentProfile = () => {
		let isCouponPopUp = false;
        if (mySelectType === "comleteUserSignUp" || signupresponse?.success) {
            isCouponPopUp = true;
        }
		if(defaultChildData?.isUserPlan){
			 history.push({
            	pathname: PATHS.MYPLAN_PAGE,
				state: {isCouponPopUp: isCouponPopUp}
        	})
		}else{
			 history.push({
            	pathname: PATHS.COURSE_CATLOG_STR + defaultChildData?.id,
            	state: {isCouponPopUp: isCouponPopUp}
        	})
		}
       
	}

	// console.log("mySelectType : ", mySelectType, signinresponse, signupresponse, defaultChildData, alluserdetails);

	const handleChild = (type) => {
		setShowChild(type);
	}

	const handleUserPinPopUp = (dataObj) => {
		/*
		if (dataObj?.userType === "PARENT" && dataObj?.isPin) {
            handleParentProfile();
			return;
        }
		*/
		setUserData(dataObj);
	}

	useEffect(() => {
		//	console.log("verifyPinResponse : ", verifyPinResponse);
		if ((userPinRespnse?.records?.length > 0 || (verifyPinResponse?.records?.length > 0 && verifyPinResponse?.records[0]?.userId))) {
			handleUserPinPopUp();
			handleParentProfile();
		}
	}, [userPinRespnse, verifyPinResponse]);

	console.log("mySelectedPlan : ", billingDetails,signupresponse, window.innerWidth);

	useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };
	// console.log("layout screen Mobile layout ", window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);




	return (
		<>	
			{windowSize <= 768 ? (
				 <div className="install_appwrap">
										<div className="bloomster_logo">
										  <img src={image.newvickylogo} alt="logo" />
											  <h3>Enjoy a Better Experience!</h3>
											  <p>Install our mobile app for faster access and smoother navigation.</p>
											  {/* <p><a href="https://apps.apple.com/us/app/bloomster/id6474612652">Bloomster</a></p> */}
										  <div className="appbtns">
										   <div class="btn-box"><a href="https://apps.apple.com/us/app/bloomster/id6474612652"> 
										   <img alt="IOS" src="https://bloomster.com/hubfs/website-pages-images/Applestore.png"  />
											</a> <a href="https://play.google.com/store/apps/details?id=com.bluffy.bloomster" > <img src="https://bloomster.com/hubfs/website-pages-images/Playstore.png" alt="ANDROID" /> </a></div>
										  </div>
										  <p><a href="https://apps.apple.com/us/app/bloomster/id6474612652">Or, Continue in Browser</a></p>
										</div>
									   </div>
			) : (
				<div className="RootContent">
				{/* <SidebarNew /> */}
				<div className="Seltprofile_sec ">
					<div className="Selprofilecontnr flexfive">
						<div className="profileheader text-center bg-darks pdt-2 pdb-2 d-flex justify-content-between  align-items-center">
							<div></div>
							<div>
								<img src={image.vicky_logo_LP} alt="logo" />
							</div>

							{/* <div className='sidebaritems pointer' onClick={() => dispatch(logoutAction(alluserdetails))}>
								<span>
									<img src={image.logout_white} alt='home' className='notactive logoutImg' />
								</span>
								<p className="text-white">Logout</p>

							</div> */}
							<div className='logoutButton mr-4 pointer' onClick={() => dispatch(logoutAction(alluserdetails))}><p className='P1'><img src={image.logout_white} alt='home' className='notactive logoutImg' /> Logout</p></div>
						</div>
						{/* <div className="profileheader text-center bg-darks pdt-2 pdb-2 ">
							<img src={image.vicky_logo_LP} alt="logo" />
						</div> */}
						<div className="myporfilelistcontnr flexfive flex-wrap">
							<h1 className="w-100 text-center mt-100">
								Please Select A Profile To Continue
							</h1>
							<div className="profileList flexfive flex-wrap">
								{userProfileResponse?.records?.length > 0 ? (
									<>
										{/* <div className="profileItem">
								<div className="myprofile_image">
									<img
										src={image.userProfile}
										alt="profile"
										className="br-50 w-100"
									/>
								</div>
								<div className="My_Profile pointer" onClick={() => handleUserPinPopUp(true)}>
									<p className="p1">
										Parent Profile{" "}
										<i class="fa-regular fa-arrow-right ml-3"></i>
									</p>
								</div>
							</div> */}''
										{userProfileResponse && userProfileResponse?.records?.map((data, index) => (
											<div className="profileItem addleaner_" key={index}>
												<div className="myprofile_image pointer" onClick={() => handleUserPinPopUp(data)}>
													<img
														src={data?.imageUrl ? data?.imageUrl : image.bluecircle}
														alt="profile"
														className="br-50 w-100"
													/>
													{
														!data?.imageUrl && (
															<div className="userintials flexfive">
																{getProfileName(data)}
															</div>
														)
													}
												</div>

												<div className="My_Profile pointer" onClick={() => handleUserPinPopUp(data)}>
													<p className="p1">
														{textTrim(getCapitalized(getName(data), 18))} <i class="fa-regular fa-arrow-right ml-3"></i>
													</p>
												</div>
											</div>
										))}
										{/* <div className="profileItem addleaner_">
								<div className="myprofile_image pointer" >
									<img
										src={image.bluecircle}
										alt="profile"
										className="br-50 w-100"
									/>
									<div className="userintials flexfive">
										AN
									</div>
								</div>
								<div className="My_Profile pointer" >
									<p className="p1">
										Adam <i class="fa-regular fa-arrow-right ml-3"></i>
									</p>
								</div>
							</div> */}
										<div className="profileItem addleaner_">
											<div className="myprofile_image  dashedborder br-50 pointer" onClick={() => handleChild(true)}>
												<img src={image.addlearnericon} alt="profile" className="br-50" />
												{/* <i class="fa-thin fa-circle-plus"></i> */}
											</div>
											<div className="My_Profile pointer" onClick={() => handleChild(true)}>
												<p className="p1">
													Add Learner<i class="fa-regular fa-arrow-right ml-3"></i>
												</p>

											</div>
										</div>
									</>
								) : (
									<ShimmerSimpleGallery imageType="circular" imageHeight={200} caption />
								)}
							</div>
						</div>
						   {/* <div className="install_appwrap">
										<div className="bloomster_logo">
										  <img src={image.newvickylogo} alt="logo" />
											  <h3>Enjoy a Better Experience!</h3>
											  <p>Install our mobile app for faster access and smoother navigation.</p>
											   <p><a href="https://apps.apple.com/us/app/bloomster/id6474612652">Bloomster</a></p> 
										  <div className="appbtns">
										   <div class="btn-box"><a href="https://apps.apple.com/us/app/bloomster/id6474612652"> 
										   <img alt="IOS" src="https://bloomster.com/hubfs/website-pages-images/Applestore.png"  />
											</a> <a href="https://play.google.com/store/apps/details?id=com.bluffy.bloomster" > <img src="https://bloomster.com/hubfs/website-pages-images/Playstore.png" alt="ANDROID" /> </a></div>
										  </div>
										  <p><a href="https://apps.apple.com/us/app/bloomster/id6474612652">Or, Continue in Browser</a></p>
										</div>
									   </div> */}

					</div>
				</div>
			</div>
			)}
			
			{showChild && (
				<AddLearner handleChild={handleChild} />
			)}
			{userData && (
				<UserPinPopUp handleUserPinPopUp={handleUserPinPopUp}
					userData={userData}
				/>
			)}
		</>
	)
}
export default UserProfile;